<template>
  <div class="mt-12 mb-32 pa-4">
    <v-expansion-panels multiple flat>
      <v-expansion-panel
        v-for="(item, index) in items"
        :key="index"
        class="custom-expansion-panel"
      >
        <v-expansion-panel-header>
          <span class="custom-header-text py-4">
            {{ item.label }}
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="item.content" class="custom-panel-content pb-4"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: function() {
        return [
          {
            label: this.$t("staking.FAQ.faq1.title"),
            content: this.$t("staking.FAQ.faq1.desc")
          },
          {
            label: this.$t("staking.FAQ.faq2.title"),
            content: this.$t("staking.FAQ.faq2.desc")
          },
          {
            label: this.$t("staking.FAQ.faq3.title"),
            content: this.$t("staking.FAQ.faq3.desc")
          },
          {
            label: this.$t("staking.FAQ.faq4.title"),
            content: this.$t("staking.FAQ.faq4.desc")
          },
          {
            label: this.$t("staking.FAQ.faq5.title"),
            content: this.$t("staking.FAQ.faq5.desc")
          },
          {
            label: this.$t("staking.FAQ.faq6.title"),
            content: this.$t("staking.FAQ.faq6.desc")
          },
          {
            label: this.$t("staking.FAQ.faq7.title"),
            content: this.$t("staking.FAQ.faq7.desc")
          }
        ];
      }
    }
  }
};
</script>

<style scoped>
.custom-expansion-panel {
  padding-inline: 32px;
  border-radius: 12px !important;
  background-color: var(--v-gray10-base) !important;
  margin-bottom: 16px !important;
}

.custom-header-text {
  font-weight: 500;
  font-size: 16px;
  color: var(--v-gray3-base);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-expansion-panel-header--active .custom-header-text {
  color: var(--v-primary-base);
}

.custom-panel-content {
  font-size: 14px;
  color: var(--v-gray3-base);
}
</style>
